module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a89ad1d0754a6ca305a1011dad503c96.png";